export interface DataId {
  id: string;
  name: string;
}

export const DISPLAY_COLUMN: string[] = [
  // 'id',
  'fileName',
  'uploadedDatetime',
  'actions',
];

export const COLUMN_LIST: DataId[] = [
  // {
  //   id: 'id',
  //   name: 'ID',
  // },
  {
    id: 'fileName',
    name: 'File Name',
  },
  {
    id: 'uploadedDatetime',
    name: 'Date',
  },
  {
    id: 'actions',
    name: 'Download',
  },
];
